import axios from "axios";
import React, {useEffect, useState} from "react";

const Api = () => {
  const [Apis, setApis] = useState({})
  let bedrijf

  useEffect( () => {
    const getAll = async () => {
      try {
        const apis = await axios.get(`/api/key/all`);

        console.log(apis);
        setApis(apis.data);
      } catch (error) {
        console.log(error);
      }
    }
    getAll();
  }, []);

  const DeleteOrganisation = async () => {
    document.getElementById("popup").style.display = "none";
    window.location.reload();
    await axios.delete(`/api/key/delete/`, {
      params: {
        naam: bedrijf
      }
    });
  }

  const confirmDeleteOrganisation = async (event, naam) => {
    document.getElementById("popup").style.display = "flex";
    bedrijf = naam;
  }

  const cancelDeleteOrganisation = async () => {
    document.getElementById("popup").style.display = "none";
  }

  const disableOne = async (e) => {
    await axios.get(`/api/key/disable/`, {
      params: {
        naam: e.target.value
      }
    });
  }

  return (
    <div className="flex flex-col items-center gap-4">
      <dialog open id={"popup"} className={"hidden shadow-sm shadow-gray-400 bg-gray-200 rounded-2xl p-3 w-72 fixed z-50 text-center gap-4 flex-col"}>
        <p className={"font-bold text-2xl"}>Weet je zeker dat je deze Api key wilt verwijderen</p>
        <div className="flex items-center justify-around">
          <button className={"p-2 bg-blue-500 rounded-full text-xl font-bold text-white w-16"} onClick={DeleteOrganisation}>Ja</button>
          <button className={"p-2 bg-blue-500 rounded-full text-xl font-bold text-white w-16"} onClick={cancelDeleteOrganisation}>Nee</button>
        </div>
      </dialog>
      <a href={"/"} className={"ml-2 mt-2 font-extrabold text-xl text-white absolute bg-orange-500 rounded-lg h-fit p-1.5 shadow-xl shadow-gray-400 left-4"}>Terug</a>
      {Apis.length ? Apis.map((api) => (
        <div className="flex flex-col p-4 px-10 pr-40 relative items-start gap-3 border-b xl:w-10/12 md:w-10/12 w-10/12 border-stone-800">
          <div className={"text-5xl font-bold"} key={api.name}>{api.naam}</div>
          <div className={"text-3xl"}>{api.code}</div>
            <div className={"absolute  md:flex hidden right-10 top-8 "}>
              <button onClick={(e) => disableOne(e)} value={api.naam} className={ api.actief ? "w-14 h-14 rounded-full shadow-xl shadow-gray-400 p-3.5 bg-green-600" : "w-14 h-14 rounded-full shadow-xl shadow-gray-400 p-3.5 bg-red-600"}></button>
              <img onClick={(event) => confirmDeleteOrganisation(event, api.naam)} className="h-14 w-14 hover:cursor-pointer" src="/delete.svg" alt="delete"/>
            </div>
        </div>
      )) : ""}
        <a href={"/api/nieuw"} className="fixed right-3 bottom-3 w-14 h-14 rounded-full bg-green-600 shadow-xl shadow-gray-400 p-3.5">
          <img src={"/Add.svg"} alt={""}/>
        </a>
    </div>
  )
}

export default Api;